import * as React from "react";
import { useSelect, Color } from "@hubper/theme";
import { Check } from "styled-icons/octicons/Check";
import { Delete } from "styled-icons/material/Delete";
import { ErrorOutline } from "styled-icons/material/ErrorOutline";
import { Cross } from "styled-icons/icomoon/Cross";
import { ChevronRight } from "styled-icons/fa-solid/ChevronRight";
import { ChevronLeft } from "styled-icons/fa-solid/ChevronLeft";
import { Search } from "styled-icons/material/Search";
import { Close } from "styled-icons/material/Close";
import { KeyboardArrowDown } from "styled-icons/material/KeyboardArrowDown";
import { ArrowUpward } from "styled-icons/material/ArrowUpward";
import { Store } from "styled-icons/material/Store";
import { CheckCircle } from "styled-icons/boxicons-solid/CheckCircle";
import { Share } from "styled-icons/material/Share";
import { Add } from "styled-icons/material/Add";
import { FilterList } from "styled-icons/material/FilterList";
import { List } from "styled-icons/material/List";
import { Download as FileDownload } from "styled-icons/boxicons-regular/Download";
import { Upload as FileUpload } from "styled-icons/boxicons-regular/Upload";
import { PersonAdd } from "styled-icons/material/PersonAdd";
import { Edit } from "styled-icons/material/Edit";
import { Assignment } from "styled-icons/material/Assignment";
import { VpnKey } from "styled-icons/material/VpnKey";
import { Settings as Settings2 } from "styled-icons/material/Settings";
import { Pause } from "styled-icons/material/Pause";
import { Forward10 } from "styled-icons/material/Forward10";
import { Replay10 } from "styled-icons/material/Replay10";
import { School } from "styled-icons/material/School";
import { Help as Exam } from "styled-icons/material/Help";
import { Audiotrack } from "styled-icons/material/Audiotrack";
import { PlayArrow } from "styled-icons/material/PlayArrow";
import { InsertLink } from "styled-icons/material/InsertLink";
import { Autorenew } from "styled-icons/material/Autorenew";
import { InsertDriveFile } from "styled-icons/material/InsertDriveFile";
import { Email } from "styled-icons/material/Email";
import { Alarm } from "styled-icons/material/Alarm";
import { FormatAlignLeft } from "styled-icons/material/FormatAlignLeft";
import { OpenInNew } from "styled-icons/material/OpenInNew";
import { Image } from "styled-icons/boxicons-regular/Image";
import { LibraryAdd } from "styled-icons/material/LibraryAdd";
import { ShowChart } from "styled-icons/material/ShowChart";
import { GridVertical } from "styled-icons/boxicons-regular/GridVertical";
import { FormatAlignRight } from "styled-icons/material/FormatAlignRight";
import { FormatAlignCenter } from "styled-icons/material/FormatAlignCenter";
import { CallSplit } from "styled-icons/material/CallSplit";
import { VerticalAlignBottom } from "styled-icons/material/VerticalAlignBottom";
import { VerticalAlignTop } from "styled-icons/material/VerticalAlignTop";
import { Warning } from "styled-icons/typicons/Warning";
import { PieChart } from "styled-icons/material/PieChart";
import { ViewList } from "styled-icons/material/ViewList";
import { DateRange } from "styled-icons/material/DateRange";
import { Visibility } from "styled-icons/material/Visibility";
import { VisibilityOff } from "styled-icons/material/VisibilityOff";
import { LocationOn } from "styled-icons/material/LocationOn";
import { Event } from "styled-icons/material/Event";
import { ArrowBack } from "styled-icons/material/ArrowBack";
import { ArrowForward } from "styled-icons/material/ArrowForward";
import { Tab } from "styled-icons/material/Tab";
import { Layer } from "styled-icons/boxicons-solid/Layer";
import { PhotoVideo } from "styled-icons/fa-solid/PhotoVideo";
import { Elec } from "styled-icons/crypto/Elec";

import {
  Admins,
  Analytics,
  Author,
  Bills,
  Chat,
  Help,
  Question,
  Home,
  IO,
  LearningApps,
  LearningPlaylist,
  Library,
  Organisation,
  Settings,
  Team,
  User
} from "./customIcons";

export const iconMap = {
  done: Check as any,
  delete: Delete as any,
  error: ErrorOutline as any,
  cross: Cross as any,
  right: ChevronRight as any,
  left: ChevronLeft as any,
  search: Search as any,
  close: Close as any,
  dropdown: KeyboardArrowDown as any,
  upload: ArrowUpward as any,
  admins: Admins as any,
  analytics: Analytics as any,
  author: Author as any,
  bills: Bills as any,
  chat: Chat as any,
  help: Help as any,
  home: Home as any,
  io: IO as any,
  apps: LearningApps as any,
  playlists: LearningPlaylist as any,
  library: Library as any,
  organisation: Organisation as any,
  settings: Settings as any,
  team: Team as any,
  users: User as any,
  warehouse: Store as any,
  elearning: School as any,
  exam: Exam as any,
  podcast: Audiotrack as any,
  video: PlayArrow as any,
  link: InsertLink as any,
  continious: Autorenew as any,
  file: InsertDriveFile as any,
  finished: CheckCircle as any,
  share: Share as any,
  add: Add as any,
  filter: FilterList as any,
  email: Email as any,
  upload2: FileUpload as any,
  download: FileDownload as any,
  addUser: PersonAdd as any,
  edit: Edit as any,
  logs: Assignment as any,
  password: VpnKey as any,
  time: Alarm as any,
  settings2: Settings2 as any,
  pause: Pause,
  replay10: Replay10,
  forward10: Forward10,
  text: FormatAlignLeft as any,
  scorm: OpenInNew as any,
  image: Image as any,
  duplicate: LibraryAdd as any,
  chart: ShowChart as any,
  drag: GridVertical as any,
  alignleft: FormatAlignLeft as any,
  aligncenter: FormatAlignCenter as any,
  alignright: FormatAlignRight as any,
  aligntop: VerticalAlignTop as any,
  alignbottom: VerticalAlignBottom as any,
  logic: CallSplit as any,
  warning: Warning as any,
  piechart: PieChart as any,
  viewlist: ViewList as any,
  list: List as any,
  date: DateRange as any,
  views: Visibility as any,
  visible: Visibility as any,
  notVisible: VisibilityOff as any,
  openInNew: OpenInNew as any,
  location: LocationOn as any,
  meetup: Event as any,
  back: ArrowBack as any,
  next: ArrowForward as any,
  micro: Elec as any,
  tab: Tab as any,
  question: Question as any,
  cards: Layer as any,
  interactive: PhotoVideo as any
};

export type IconName = keyof typeof iconMap;

type Props = {
  name: IconName;
  className?: string;
  size?: string | number;
  style?: React.CSSProperties;
  c?: Color | string;
  onClick?: any;
};

function Icon(
  { name, className, style = {}, size = 16, c = "inherit", ...rest }: Props,
  ref: any
) {
  const Component = iconMap[name];

  const { color } = useSelect();

  if (Component) {
    return (
      <Component
        ref={ref}
        style={{
          // @ts-ignore
          color: color(c),
          ...style
        }}
        size={size}
        className={`icon ${className || ""}`}
        {...rest}
      />
    );
  }

  return null;
}

export default React.forwardRef(Icon);
